import { useNavigate } from "react-router-dom";
import { History } from "lucide-react";
import { useAuth } from "@/modules/auth/hooks/useAuth";
import { Button } from "@/shared/components/form/Button";
import useTranslations from "@/shared/lang/useTranslations";

type QuoterHeaderProps = {
  titleSuffix?: string;
};

export const QuoterHeader = ({ titleSuffix = "" }: QuoterHeaderProps) => {
  const { t } = useTranslations("quoter");
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  return (
    <div className="p-8 pb-0 flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          {`${t("header_title")}${titleSuffix}`}
        </h1>
        <p className="text-gray-500 dark:text-zinc-400">
          {t("header_subtitle")}
        </p>
      </div>
      {isAdmin && (
        <Button
          type="button"
          variant="primary"
          className="bg-green-600 hover:bg-green-700 active:bg-green-800 dark:bg-green-500 dark:hover:bg-green-600 dark:active:bg-green-700"
          icon={<History className="size-4" />}
          iconPosition="left"
          onClick={() => navigate("/app/quoter/history")}
        >
          {t("header_history_button")}
        </Button>
      )}
    </div>
  );
};
